import { render, staticRenderFns } from "./JobPriorityPicker.vue?vue&type=template&id=6586b5b1&"
import script from "./JobPriorityPicker.vue?vue&type=script&lang=ts&"
export * from "./JobPriorityPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports